export default "__VITE_ASSET__B21ipdHP__"